const routes = {
  LOGIN: "/login",
  LOGOUT: "/logout",
  GET_USER_DETAILS: "/users/user",
  PATCH_USER_DETAILS: "/users/",
  SUPPLIERS: "/Supplier",
  SUPPLIER_CHANGES: "/supplier_changes_details",
  GET_SUPPLIER_CHANGES_DATES: "/supplier_changes/dates/",

  GET_SUPPORT_TICKETS: "/support_tickets/",
  GET_SUPPORT_TICKET_TYPE_LIST: "/support_ticket_types/",
  POST_SUPPORT_TICKET: "/support_tickets/",

  GET_STATUS_LIST: "/status/",
  GET_SUPPLIER_REQUEST_LOGS: "/supplier_request",

  GET_RECENT_ACTIVITY: "/activity/",
  GET_CURRENT_USERS_SUPPLIERS: "/user_supplier/current_user_supplier_details",

  GET_RECENT_SUPPLIER_UPDATES:
    "/supplier_request/recent_supplier_update_current_user",

  SUPPLIER_CUSTOM_REQUEST: "/custom_request/",

  GET_CUSTOM_REQUEST: "/custom_request/",
  GET_CUSTOM_REQUEST_FILES: "/supplier_changes_details/by_supplier_request_id",

  GET_USERS_LIST: "/users/users",

  GET_ROLES: "/roles",
  ADMIN_CREATE_USER: "admins_user_management/",
  ADMIN_USER_MODIFY: "admins_user_management/",

  USER_ASSOCIATED_SUPPLIER: "user_supplier/",
  PATCH_USER_ASSOCIATED_SUPPLIER: "user_supplier/modify_suppliers/",
  GET_USER_LOGIN_ACTIVITY: "/login_activity/",

  VERIFY_TOKEN_ONBOARDING: "/user_password_management/",
  TOKEN_SET_PASSWORD: "user_password_management/set_password/",

  FORGET_PASSWORD: "user_password_management/forget_password/",

  ADMIN_RESEND_INVITATION: "admins_user_management/resend_invitation_email/",
  TOGGLE_FAVOURITE_SUPPLIER: "user_supplier/toggle_favourite/",

  CHANGE_PASSWORD: "/users/modify_password/",
};

export default routes;
